import { SFTP_AUTHENTICATION_MODE } from './paymentsManagerConfiguration.constants';

const emptyForm = {
  host: '',
  port: '22',
  username: '',
  authentication_mode: SFTP_AUTHENTICATION_MODE.PASSWORD,
  password: '',
  private_key: '',
  outbound_path: '',
  inbound_path: '',
  payments_manager_prefix: '',
  ack_prefix: '',
  notification_prefix: '',
  recon_prefix: '',
};

export const toPaymentsManagerForm = (configuration) => {
  if (!configuration) {
    return emptyForm;
  }

  return {
    host: configuration.host,
    port: String(configuration.port),
    username: configuration.username,
    authentication_mode: configuration.authenticationMode,
    password: '',
    private_key: '',
    outbound_path: configuration.outboundPath,
    inbound_path: configuration.inboundPath,
    payments_manager_prefix: configuration.paymentsManagerPrefix,
    ack_prefix: configuration.ackPrefix,
    notification_prefix: configuration.notificationPrefix,
    recon_prefix: configuration.reconPrefix,
  };
};
